import { isProdNodeEnv } from '@rover/rsdk/src/modules/Env/node';
import { Logger } from '@rover/rsdk/src/modules/Logging';

export const logError = (error: Error, metadata: Record<string, string> = {}): void => {
  if (isProdNodeEnv()) {
    Logger.error(error, metadata);
  } else {
    // eslint-disable-next-line no-console
    console.error(error, metadata);
  }
};
